export const CMD = {
  PDF_TO_WORD: 'pdf_to_word',
  PDF_TO_IMG: 'pdf_to_img',
  PDF_TO_PPT: 'pdf_to_ppt',
  PDF_TO_EXCEL: 'pdf_to_excel',
  PDF_TO_TXT: 'pdf_to_txt',
  PDF_TO_CAD: 'pdf_to_cad',
  CAD_TO_PDF: 'cad_to_pdf',
  IMG_TO_PDF: 'img_to_pdf',
  WORD_TO_PDF: 'word_to_pdf',
  PPT_TO_PDF: 'ppt_to_pdf',
  EXCEL_TO_PDF: 'excel_to_pdf'
}

export const NAV_HOME = { parent: { id: 1, name: '首页', routeName: 'Home' } }

export const NAV_LIST = [
  {
    parent: { id: 2, name: 'PDF转换', routeName: 'Pdf2word' },
    children: [
      { id: 1, name: 'PDF转Word', coverTitle: 'PDF 转 Word', routeName: 'Pdf2word', parentId: 2, iconName: 'common_icon_hot' },
      { id: 2, name: 'PDF转图片', coverTitle: 'PDF 转 图片', routeName: 'Pdf2jpg', parentId: 2, iconName: 'common_icon_recommend' },
      { id: 3, name: 'PDF转PPT', coverTitle: 'PDF 转 PPT', routeName: 'Pdf2ppt', parentId: 2 },
      { id: 4, name: 'PDF转Excel', coverTitle: 'PDF 转 Excel', routeName: 'Pdf2excel', parentId: 2 },
      { id: 5, name: 'PDF转TXT', coverTitle: 'PDF 转 TXT', routeName: 'Pdf2txt', parentId: 2 }
    ]
  },
  {
    parent: { id: 3, name: '转换成PDF', routeName: 'Word2pdf' },
    children: [
      { id: 1, name: 'Word转PDF', coverTitle: 'Word 转 PDF', routeName: 'Word2pdf', parentId: 3, iconName: 'common_icon_hot' },
      { id: 2, name: '图片转pdf', coverTitle: '图片 转 PDF', routeName: 'Jpg2pdf', parentId: 3, iconName: 'common_icon_hot' },
      { id: 3, name: 'PPT转PDF', coverTitle: 'PPT 转 PDF', routeName: 'Ppt2pdf', parentId: 3 },
      { id: 4, name: 'Excel转PDF', coverTitle: 'Excel 转 PDF', routeName: 'Excel2pdf', parentId: 3 }
    ]
  },
  {
    parent: { id: 4, name: '图片转换', routeName: 'Pdf2jpg' },
    children: [
      { id: 1, name: 'PDF转图片', coverTitle: 'PDF 转 图片', routeName: 'Pdf2jpg', parentId: 4, query: { group_name: 'img1' } },
      { id: 2, name: '图片转PDF', coverTitle: '图片 转 PDF', routeName: 'Jpg2pdf', parentId: 4, query: { group_name: 'img2' } },
      { id: 3, name: 'PDF转JPG', coverTitle: 'PDF 转 JPG', routeName: 'Pdf2jpg', parentId: 4, query: { group_name: 'img3' } },
      { id: 4, name: 'PDF转PNG', coverTitle: 'PDF 转 PNG', routeName: 'Pdf2png', parentId: 4 },
      { id: 5, name: 'PDF转BMP', coverTitle: 'PDF 转 BMP', routeName: 'Pdf2bmp', parentId: 4 }
    ]
  },
  // {
  //   parent: { id: 5, name: 'PDF处理', routeName: 'Pdf2merge' },
  //   children: [
  //     { id: 1, name: 'PDF合并', coverTitle: 'PDF合并', routeName: 'Pdf2merge', parentId: 5 },
  //     { id: 2, name: 'PDF拆分', coverTitle: 'PDF拆分', routeName: 'Pdf2split', parentId: 5 },
  //     { id: 3, name: 'PDF加密', coverTitle: 'PDF加密', routeName: 'Pdf2encrypt', parentId: 5 },
  //     { id: 4, name: 'PDF删除页面', coverTitle: 'PDF删除页面', routeName: 'Pdf2delete', parentId: 5 },
  //     { id: 5, name: 'PDF添加水印', coverTitle: 'PDF添加水印', routeName: 'excel2pdfPdf2watermark', parentId: 5 },
  //     { id: 6, name: 'PDF页面提取', coverTitle: 'PDF页面提取', routeName: 'Pdf2Pageextraction', parentId: 5 },
  //     { id: 7, name: 'PDF提取图片', coverTitle: 'PDF提取图片', routeName: 'Pdf2getimg', parentId: 5 }
  //   ]
  // },
  {
    parent: { id: 6, name: 'CAD转换', routeName: 'Pdf2cad' },
    children: [
      { id: 1, name: 'PDF转CAD', coverTitle: 'PDF 转 CAD', routeName: 'Pdf2cad', parentId: 6 },
      { id: 2, name: 'CAD转PDF', coverTitle: 'CAD 转 PDF', routeName: 'Cad2pdf', parentId: 6 }
    ]
  }
]

/** 常见问题、客户端下载及PPT素材等入口，提升产品边界 */
export const NAV_HELP = [
  // { parent: { id: 9, name: '常见问题', routeName: 'help', isSelf: true } }
]

/** 帮助文档 */
export const HELP_LIST = [
  {
    title: '功能使用相关', questionList: [
      { question: '1.在线上传文件是否限制文件大小?', answer: '答：在线版PDF转换器转换文件仅限于50M以内文件，如需转换更大文件、转换更多格式文件，请使用客户端或开通VIP。' },
      { question: '2.PDF转换为其他格式文件后要到哪里查看?', answer: '答：PDF文件转换成其他格式文件后，请到“我的文件”选项中下载文件。' },
      { question: '3.PDF转换为其他格式文件或者其他文件转换为PDF后是否免费?', answer: '答：毒霸PDF在线转换器完全免费，可为用户提供2页免费转换服务，若需要使用更高快速及更优的的转换效果，可成为毒霸VIP后进行转换。' },
      { question: '4.毒霸PDF在线转换器可以转换哪些格式文件?', answer: '答：毒霸PDF在线转换器为用户提供高效的PDF转换服务，不仅可以将WPS、office等文件转换为PDF文件，也可以将PDF文件转换成各类型文件，也可以将包括doc、docx、xls、xlsx、ppt等文件转换成PDF文件。' },
      { question: '5.可以将CAD文件转换成PDF文件，或将PDF文件转换为CAD文件吗?', answer: '答：毒霸PDF在线转换器支持CAD文件转换，包括将dwg文件转换成PDF格式，以及PDF格式文件转换为dwg文件，为用户提供高效的PDF转换服务。' },
      { question: '6.PDF中内容不能复制怎么办？如何复制PDF内容？', answer: '答：相对于Word、Excel等格式来说，PDF有着自己独特的优点，那就是方便阅读与管理;但是如何将PDF文件内容复制去别的文件中呢？方法1：如果PDF内容支持复制，可直接复制文件内容至其他文件。方法2：当PDF文件内容无法复制时，我们可以采用毒霸PDF提供的“增强图文转换”模式，尝试将文件转换成doc或docx等格式，就能随意复制转换成功的内容了。' },
      { question: '7.有办法将PDF中部分内容如何转换为图片吗，以及图片内容如何转换为PDF？', answer: '答：毒霸PDF转换器提供PDF转图片及图片转PDF功能，用户可点击“图片转换”功能，将PDF内容转换成图片，支持针对某几个页面单独转换为图片、控制输出图片格式等，或将图片内容转换成PDF文件，还支持控制输出格式、页面大小、页面边距等操作。' },
      { question: '8.如何编辑PDF内容，删除PDF页面，或将PDF加密？', answer: '答：可通过可牛办公客户端提供的PDF转换功能，实现删除PDF页面、加密等效果，利用毒霸客户端PDF转换器还可以实现PDF旋转页面、提取PDF页面、PDF拼接页面等功能。' }
    ]
  },
  {
    title: '登录/注册相关', questionList: [
      { question: '1.在线PDF转换器注册方式有哪些?', answer: '答：在线PDF转换器可直接使用手机号码或微信、qq等登录。' },
      { question: '2.在线PDF转换器登录方式有哪些?', answer: '答：用户可使用手机号、QQ或微信登录毒霸PDF转换器。' }
    ]
  },
  {
    title: 'VIP相关', questionList: [
      { question: '1.开通VIP可享受哪些服务?', answer: '答：免费用户可转换2个文件,用户开通VIP后可实现在线转换更多的文件（单个文件上限50M），享受金山毒霸会员权益，在客户端中可任意使用PDF转换功能，并享受免费在线技术支持服务。' },
      { question: '2.毒霸PDF在线转换器是什么？', answer: '答：毒霸PDF在线转换器是可牛办公为用户提供的支持全套的PDF转换操作的软件,毒霸在线转换PDF永久免费,使用毒霸客户端提供的PDF转换器还可以PDF解密去除限制、各种PDF转换、PDF旋转页面、PDF删除页面、提取PDF页面、PDF拼接页面等功能。' },
      { question: '3.VIP有哪些套餐?', answer: '答：毒霸VIP套餐开设了35元/3个月、98元/1年、198元/3年等VIP套餐，用户可根据自己的实际情况进行选择。具体套餐介绍可到“开通VIP”选项中查看。' }
    ]
  }
]

export const HOME_CONVERT_NAV_LIST = [
  {
    type: 'PDF在线转换',
    list: [
      { routeName: 'Pdf2word', name: 'PDF 转 Word', className: 'home_icon_pdf2word', isHot: true },
      { routeName: 'Pdf2excel', name: 'PDF 转 Excel', className: 'home_icon_pdf2excel' },
      { routeName: 'Pdf2ppt', name: 'PDF 转 PPT', className: 'home_icon_pdf2ppt' },
      { routeName: 'Pdf2jpg', name: 'PDF 转 图片', className: 'home_icon_pdf2jpg' },
      { routeName: 'Pdf2txt', name: 'PDF 转 TXT', className: 'home_icon_pdf2txt' },
      { routeName: 'Word2pdf', isHot: true, name: 'Word 转 PDF', className: 'home_icon_word2pdf' },
      { routeName: 'Excel2pdf', name: 'Excel 转 PDF', className: 'home_icon_excel2pdf' },
      { routeName: 'Ppt2pdf', name: 'PPT 转 PDF', className: 'home_icon_ppt2pdf' },
      { routeName: 'Jpg2pdf', isHot: true, name: '图片 转 PDF', className: 'home_icon_pic2pdf' },
    ]
  },
  {
    type: 'CAD转换',
    list: [
      { routeName: 'Pdf2cad', name: 'PDF 转 CAD', className: 'home_icon_pdf2cad' },
      { routeName: 'Cad2pdf', name: 'CAD 转 PDF', className: 'home_icon_cad2pdf' },
    ]
  }
]

// 接口类型，用来区分外部和自家接口
export const INTERFACE_TYPE = {
  TENCENT: 'tt', // 腾讯云,
  SELF: 'self', // 自家
  CUSTOM: 'custom', // 自定义错误类型
  TENCENT_COS_UPLOAD_FAIL: 'tencent_cos_upload_fail' // 腾讯云上传文件失败
}

export const FILE_STATUS = {
  CONVERT_SUCCESS: 'CONVERT_SUCCESS', // 转换成功
  CONVERT_FAIL: 'CONVERT_FAIL', // 转换失败
  CONVERT_ING: 'CONVERT_ING', // 转换进行中
  LOADED_FILE: 'LOADED_FILE' // 加载文件到网页
}

export const COVERT_TYPE = {
  PDF_2_WORD: 'PDF_2_WORD'
}

export const COVERT_CONFIG = {
  [COVERT_TYPE.PDF_2_WORD]: {
    cmd: 'pdf_to_word'
  }
}

export const FILE_TYPE = {
  PDF: 'pdf',
  WORD: 'word',
  JPG: 'jpg',
  EXCEL: 'excel',
  TXT: 'txt',
  BMP: 'bmp',
  CAD: 'cad',
  PPT: 'ppt',
  IMG: 'img',
  NONE: 'none',
  PNG: 'png'
}

export const FILE_TYPE_CHINESE = {
  [FILE_TYPE.PDF]: 'PDF',
  [FILE_TYPE.WORD]: 'Word',
  [FILE_TYPE.JPG]: 'JPG',
  [FILE_TYPE.EXCEL]: 'Excel',
  [FILE_TYPE.TXT]: 'TXT',
  [FILE_TYPE.BMP]: 'BMP',
  [FILE_TYPE.CAD]: 'CAD',
  [FILE_TYPE.PPT]: 'PPT',
  [FILE_TYPE.IMG]: '图片',
  [FILE_TYPE.NONE]: '',
  [FILE_TYPE.PNG]: 'PNG'
}

// 文件后缀名
export const FILE_SUFFIX_TYPE = {
  [FILE_TYPE.PDF]: ['pdf'],
  [FILE_TYPE.WORD]: ['docx', 'doc'],
  [FILE_TYPE.JPG]: ['jpg'],
  [FILE_TYPE.EXCEL]: ['xlsx', 'xls'],
  [FILE_TYPE.TXT]: ['txt'],
  [FILE_TYPE.BMP]: ['bpm'],
  [FILE_TYPE.CAD]: ['dwg', 'dxf'],
  [FILE_TYPE.PPT]: ['pptx', 'ppt'],
  [FILE_TYPE.IMG]: ['jpg', 'png', 'bmp'],
  [FILE_TYPE.PNG]: ['png']
}

// 转换页面的类型
export const COVERT_PAGE_TYPE = {
  EVERY: 'EVERY', // 每页都转
  RANGE: 'RANGE' // 转一个区间，如3-5
}

// 转换后的目标文件类型
export const COVERT_TARGET_TYPE = {
  DOCX: 'docx',
  DOC: 'doc',
  PPTX: 'pptx',
  PPT: 'ppt',
  XLSX: 'xlsx',
  XLS: 'xls',
  JPG: 'jpg',
  PNG: 'png',
  BMP: 'bmp',
  PDF: 'pdf',
  TXT: 'txt',
  DWG: 'dwg',
  DXF: 'dxf'
}

export const EXP_PAGE_RANGE = /^(\d+)-(\d+)$/

export const CUSTOM_OPTION_TYPE = {
  NORMAL: 'NORMAL',
  CAD_TO_PDF: 'CAD_TO_PDF',
  IMG_TO_PDF: 'IMG_TO_PDF'
}

export const CONVERT_RESULT = {
  SUCCESS: 1, // 转换成功
  FAIL: 2 // 转换失败
}

export const CONVERT_RESULT_TEXT = {
  [CONVERT_RESULT.SUCCESS]: '转换成功',
  [CONVERT_RESULT.FAIL]: '转换失败'
}

// 支持高级转换的命令-图文增强
export const SUPPRT_ADVANCED_CONVERT = {
  [CMD.PDF_TO_WORD]: true,
  [CMD.PDF_TO_PPT]: true,
  [CMD.PDF_TO_EXCEL]: true
}

export const CMD_TEXT = {
  [CMD.PDF_TO_WORD]: 'PDF转Word',
  [CMD.PDF_TO_IMG]: 'PDF转图片',
  [CMD.PDF_TO_PPT]: 'PDF转PPT',
  [CMD.PDF_TO_EXCEL]: 'PDF转Excel',
  [CMD.PDF_TO_TXT]: 'PDF转TXT',
  [CMD.PDF_TO_CAD]: 'PDF转CAD',
  [CMD.CAD_TO_PDF]: 'CAD转PDF',
  [CMD.IMG_TO_PDF]: '图片转pdf',
  [CMD.WORD_TO_PDF]: 'Word转PDF',
  [CMD.PPT_TO_PDF]: 'PPT转PDF',
  [CMD.EXCEL_TO_PDF]: 'Excel转PDF'
}

export const ERR_CODE = {
  CONVERT_TIMES_LIMIT: 4103008 // 转换次数限制
}

export const ERR_CODE_MSG = {
  4103002: '系统异常 4103002',
  4103003: '系统异常 4103003',
  4103004: '需要会员权限，请先购买会员 4103004',
  4103005: '系统异常 4103005',
  4103006: '系统异常 4103006',
  4103007: '系统异常 4103007',
  [ERR_CODE.CONVERT_TIMES_LIMIT]: '已超过转换次数限制，请先购买会员 4103008',
  4103009: '普通用户只能转换2页 4103009'
}

export const CONVERT_TYPE = {
  NORMAL: 1, // 普通转换
  OCR: 2 // OCR增强转换
}
